<template>
    <el-dialog
        :visible.sync="spcs.openShow"
        :show-close="false"
        :close-on-click-modal="false"
        @opened="handleOpen"
    >
        <div style="box-sizing: border-box;padding: 20px;height: 100%;">
            <div style="height: calc(100% - 90px);background-color: #f7f7f7;padding: 20px;">
                <div style="display: flex;margin-bottom:20px;">
                    <div style="margin: 0 10px;font-weight: 700;font-size: 18px;height: 40px;line-height: 40px;color: #343434;">
                        <span>{{ tzxxName }}</span>
                    </div>
                    <el-image class="tabDelImg" :src="require('../../assets/tab-del.png')" @click="handleClose"></el-image>
                </div>
                <div style="height: 100%">
                    <video id="videoPlayer" muted autoplay loop controls style="width: 100%;height: 100%;"></video>
                </div>
            </div>
        </div>
    </el-dialog>
</template>
  
<script>
export default {
    props:{
        spcs:{
            type:Object
        },
    },
    data() {
        return {
            tzData: [],
            tzxxData: {},
            tzxxName:'',
            
            
            tzDataX: {
                spDialogVisible: false,
            },
            percentage: 1,
            xzIndex: 0,
            bfzt:false,

            webRtcServer: null,
        }
    },
    methods: {
        handleOpen(){
            this.tzxxName = this.spcs.cz.stnm;
            this.webRtcServer = new WebRtcStreamer("videoPlayer","http://127.0.0.1:8000");
            this.webRtcServer.connect(this.spcs.cz.path);
        },
        handleClose() {
            this.spcs.openShow = false;
            this.webRtcServer.disconnect();
            this.webRtcServer = null;
        },
    },
}
</script>
<style scoped>
::v-deep .el-dialog{
    margin-top: 110px !important;
    margin-bottom:0;
    width: 100% !important; 
    height: calc(100% - 110px);
}
/*去除头部*/
::v-deep .el-dialog__header{
    display: none;
}
/*去除尾部*/
::v-deep .el-dialog__footer{
    display: none;
}
::v-deep .el-dialog__body{
    height: 100%;
    padding: 0px;
}


.tabDelImg {
    width: 3rem;
    height: 3rem;
    cursor: pointer;
    position: absolute;
    right: 40px;
}


/deep/ ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}
/deep/ ::-webkit-scrollbar-track {
    --webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 6px;
}
/deep/ ::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: rgb(220, 220, 220);
    --webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.5);
}
/deep/ ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(220,220,220,0.4);
}
</style>